"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPostMailLetterDesignSelectorCatalogEntries = exports.normalizePostMailLetterDesignId = exports.isSelectablePostMailLetterDesignId = exports.isValidPostMailLetterDesignIdForSave = exports.isKnownPostMailLetterDesignId = exports.isDecoratedPostMailLetterDesign = exports.getSelectablePostMailLetterDesignCatalogEntries = exports.getPostMailLetterDesignI18nKeySuffix = exports.POST_MAIL_LETTER_DESIGN_IDS = exports.POST_MAIL_LETTER_DESIGN_CATALOG = exports.POST_MAIL_DECORATED_LETTER_DESIGN_IDS = exports.PostMailLetterDesignId = void 0;
const predicate_1 = require("../helpers/predicate");
exports.PostMailLetterDesignId = {
    Classic: "classic",
};
const POST_MAIL_LETTER_DESIGN_CATALOG_SOURCE = [
    {
        id: "bubbly_paint_corners_v1",
        svgFileName: "bubbly-paint-corners-v1.svg",
        selectableInEditor: true,
    },
    {
        id: "convex_rounded_corners_v1",
        svgFileName: "convex-rounded-corners-v1.svg",
        selectableInEditor: true,
    },
    {
        id: "curvy_corners_v1",
        svgFileName: "curvy-corners-v1.svg",
        selectableInEditor: true,
    },
    {
        id: "gradient_lines_corners_v1",
        svgFileName: "gradient-lines-corners-v1.svg",
        selectableInEditor: false,
    },
    {
        id: "hyperbolic_curved_corners_v1",
        svgFileName: "hyperbolic-curved-corners-v1.svg",
        selectableInEditor: true,
    },
    {
        id: "paint_stains_v1",
        svgFileName: "paint-stains-v1.svg",
        selectableInEditor: true,
    },
    {
        id: "paintbrush_corners_v1",
        svgFileName: "paintbrush-corners-v1.svg",
        selectableInEditor: true,
    },
    {
        id: "psychedelic_curvy_lines_v1",
        svgFileName: "psychedelic-curvy-lines-v1.svg",
        selectableInEditor: false,
    },
    {
        id: "straight_bottom_border_line_v1",
        svgFileName: "straight-bottom-border-line-v1.svg",
        selectableInEditor: true,
    },
    {
        id: "straight_left_border_line_v1",
        svgFileName: "straight-left-border-line-v1.svg",
        selectableInEditor: false,
    },
    {
        id: "straight_oriented_corners_v1",
        svgFileName: "straight-oriented-corners-v1.svg",
        selectableInEditor: false,
    },
    {
        id: "winter_snow_v1",
        svgFileName: "winter-snow-v1.svg",
        selectableInEditor: true,
    },
];
exports.POST_MAIL_DECORATED_LETTER_DESIGN_IDS = POST_MAIL_LETTER_DESIGN_CATALOG_SOURCE.map((entry) => entry.id);
exports.POST_MAIL_LETTER_DESIGN_CATALOG = POST_MAIL_LETTER_DESIGN_CATALOG_SOURCE.map((entry, index) => ({
    ...entry,
    displayOrder: index + 1,
}));
exports.POST_MAIL_LETTER_DESIGN_IDS = [
    exports.PostMailLetterDesignId.Classic,
    ...exports.POST_MAIL_DECORATED_LETTER_DESIGN_IDS,
];
const decoratedLetterDesignIdSet = new Set(exports.POST_MAIL_DECORATED_LETTER_DESIGN_IDS);
const catalogEntryById = new Map(exports.POST_MAIL_LETTER_DESIGN_CATALOG.map((entry) => [entry.id, entry]));
const getPostMailLetterDesignI18nKeySuffix = (designId) => {
    if (designId === exports.PostMailLetterDesignId.Classic) {
        return exports.PostMailLetterDesignId.Classic;
    }
    const entry = catalogEntryById.get(designId);
    return entry ? entry.svgFileName.replace(/\.svg$/, "") : exports.PostMailLetterDesignId.Classic;
};
exports.getPostMailLetterDesignI18nKeySuffix = getPostMailLetterDesignI18nKeySuffix;
const getSelectablePostMailLetterDesignCatalogEntries = () => [...exports.POST_MAIL_LETTER_DESIGN_CATALOG]
    .filter((entry) => entry.selectableInEditor)
    .sort((left, right) => left.displayOrder - right.displayOrder);
exports.getSelectablePostMailLetterDesignCatalogEntries = getSelectablePostMailLetterDesignCatalogEntries;
const isDecoratedPostMailLetterDesign = (designId) => !(0, predicate_1.isNullOrUndefined)(designId) &&
    designId !== exports.PostMailLetterDesignId.Classic &&
    decoratedLetterDesignIdSet.has(designId);
exports.isDecoratedPostMailLetterDesign = isDecoratedPostMailLetterDesign;
const isKnownPostMailLetterDesignId = (designId) => {
    if ((0, predicate_1.isNullOrUndefined)(designId)) {
        return false;
    }
    return designId === exports.PostMailLetterDesignId.Classic || decoratedLetterDesignIdSet.has(designId);
};
exports.isKnownPostMailLetterDesignId = isKnownPostMailLetterDesignId;
const isValidPostMailLetterDesignIdForSave = (designId) => (0, exports.isKnownPostMailLetterDesignId)(designId);
exports.isValidPostMailLetterDesignIdForSave = isValidPostMailLetterDesignIdForSave;
const isSelectablePostMailLetterDesignId = (designId) => {
    if ((0, predicate_1.isNullOrUndefined)(designId) || designId === exports.PostMailLetterDesignId.Classic) {
        return true;
    }
    const catalogEntry = catalogEntryById.get(designId);
    return catalogEntry?.selectableInEditor === true;
};
exports.isSelectablePostMailLetterDesignId = isSelectablePostMailLetterDesignId;
const normalizePostMailLetterDesignId = (designId) => {
    if ((0, predicate_1.isNullOrUndefined)(designId) || designId === exports.PostMailLetterDesignId.Classic) {
        return exports.PostMailLetterDesignId.Classic;
    }
    if (decoratedLetterDesignIdSet.has(designId)) {
        return designId;
    }
    return exports.PostMailLetterDesignId.Classic;
};
exports.normalizePostMailLetterDesignId = normalizePostMailLetterDesignId;
const getPostMailLetterDesignSelectorCatalogEntries = (selectedDesignId) => {
    const selectableEntries = (0, exports.getSelectablePostMailLetterDesignCatalogEntries)();
    if (selectedDesignId &&
        decoratedLetterDesignIdSet.has(selectedDesignId) &&
        !selectableEntries.some((entry) => entry.id === selectedDesignId)) {
        const nonSelectableEntry = catalogEntryById.get(selectedDesignId);
        if (nonSelectableEntry) {
            return [...selectableEntries, nonSelectableEntry].sort((left, right) => left.displayOrder - right.displayOrder);
        }
    }
    return selectableEntries;
};
exports.getPostMailLetterDesignSelectorCatalogEntries = getPostMailLetterDesignSelectorCatalogEntries;
